import React, { useState, useEffect } from "react";
import {
  Button,
  Row,
  Card,
  Image,
  Col,
  Form,
  Typography,
  message,
  Upload,
  Input,
  Spin,
} from "antd";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { useForm, Controller } from "react-hook-form";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import BreadCrumb from "../../../atoms/BreadCrumb";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { InputField } from "../../../atoms/FormElement";
import axios from "../../../../utils/axiosInceptor";
import { adminService } from "../../../../configs/constants";
import { SelectField } from "../../../atoms/FormElement";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { getCMSDetail } from "../ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getContentCategories } from "../ducks/actions";
import { getSingleUpload, uniquiFileName } from "../../../../utils/fileUpload";
import { s3BucketUrl } from "../../../../configs/constants";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined spin />;
const breadcrumbList: any = [
  {
    label: "CMS",
    route: "/cms",
  },
  {
    label: "Update CMS",
  },
];

const defaultValues: any = {
  key: "",
  name: "",
  cms_categories: "",
  meta_desc: "",
  cms_media: "",
  cms_media_type: "",
};

const { Paragraph, Title } = Typography;

const CMSDetail = () => {
  const { id } = useParams();
  const dispatch:any = useDispatch();
  const [editorData, setEditorData] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const { control, formState: { errors }, handleSubmit, setValue } = useForm({
    defaultValues,
  });
  const history = useNavigate();
  const contentCategories = useSelector((state:any) => state.cms.categoriesData);
  const cmsDetail = useSelector((state:any) => state.cms.cmsDetail);
  const staticImageURL = `${s3BucketUrl}/${cmsDetail?.cms_media}`;
  const [newImage, setNewimage] = useState(false);
  const [loading, setLoading] = useState(false);

  const dummyRequest = (response) => {
    setNewimage(true);
    setTimeout(() => {
      response.onSuccess("ok");
    }, 0);
  };

  useEffect(() => {
    dispatch(getCMSDetail(id));
    dispatch(getContentCategories());
  }, []);

  useEffect(() => {
    if (Object.keys(cmsDetail).length) {
      setValue("name", cmsDetail.name);
      const cat_values = [];
      cmsDetail.category.map((value) => {
        contentCategories.map((value1, key1) => {
          if (value === value1.name) {
            cat_values.push({ value: value1.id, label: value1.name });
          }
        });
      });
      setValue("cms_categories", cat_values);
      var xa = {
        uid: "12",
        name: cmsDetail.cms_media,
        status: "done",
        url: "",
      };
      if (cmsDetail?.meta_desc) {
        const state = EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(cmsDetail.meta_desc).contentBlocks,
          ),
        );
        const stateData = draftToHtml(convertToRaw(state.getCurrentContent()));

        setEditorState(state);
        setEditorData(stateData);
      }
    }
  }, [cmsDetail]);

  const onEditorStateChange = (editorState) => {
    const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setEditorData(data);
    setEditorState(editorState);
  };

  const onFinish = async (values) => {
    setLoading(true);
    if (editorState.getCurrentContent().hasText() == false) {
      message.error("Body is not allowed to be empty");
      setLoading(false);
      return false;
    }

    let modifiedName = !newImage
      ? cmsDetail?.cms_media
      : uniquiFileName(values.image.fileList[0].originFileObj.name);
    newImage &&
      (await getSingleUpload(
        modifiedName,
        values.image.fileList[0].originFileObj,
      ));

    const { name } = values;
    let cat_id = values.cms_categories.map((value, key) => ({
      id: value.value,
    }));
    const postJson = {
      name,
      cms_categories: cat_id,
      meta_tag: "#Lorem,#Ipsum, #six",
      meta_desc: editorData,
      cms_media_type: "image",
      cms_media: modifiedName,
    };

    console.log("postJson", postJson);
    const url = `${adminService}/cms/edit/${id}`;
    try {
      await axios.put(url, postJson, { headers: { application: 4 } });
      setTimeout(() => {
        message.success("Updated successfully");
        setLoading(false);
        history("/cms");
        setNewimage(false);
      }, 3000);
    } catch (e) {
      const { response } = e;
      console.log("checasdk", response);
      setLoading(false);
      message.error(response?.data?.result);
    }
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <DashboardLayout>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <BreadCrumb name="CMS" link="/cms" list={breadcrumbList} />
          </Col>
          <Col span={24}>
            <Title level={2}>Update CMS</Title>
          </Col>
          <Col span={24}>
            <Card
              bordered={false}
              bodyStyle={{ padding: "32px 32px" }}
              className="h-auto"
            >
              <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
                <Row gutter={24}>
                  <Col span={24}>
                    <Title level={3}>Edit Details</Title>
                  </Col>
                  <Col span={24}>
                    <Row gutter={24}>
                      <Col span={8}>
                        <Form.Item
                          required={cmsDetail?.cms_media ? false : true}
                          label="Upload Feature Image"
                          validateStatus={errors.image && "error"}
                          // help={
                          //   !cmsDetail?.cms_media &&
                          //   errors.image &&
                          //   errors.image.message
                          // }
                        >
                          <Controller
                            name="image"
                            control={control}
                            rules={{
                              required: cmsDetail?.cms_media ? false : true,
                            }}
                            defaultValue=""
                            render={({ field: {value, onChange} }) => (
                              <Upload
                                showUploadList={false}
                                accept="image/*"
                                maxCount={1}
                                customRequest={dummyRequest}
                                onChange={(e) => onChange(e)}
                                className="uploadWithbtn"
                              >
                                <Input
                                  size="large"
                                  value={
                                    value
                                      ? value.fileList[0].name
                                      : "Choose file"
                                  }
                                  addonAfter="Browse"
                                />
                              </Upload>
                            )}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <div className="centerImage">
                          <Image
                            width={90}
                            src={staticImageURL}
                            className="centerImage"
                            fallback="data:image/png;base64,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"
                            placeholder={
                              <Image
                                preview={false}
                                src={staticImageURL}
                                width={250}
                              />
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={8}>
                    <InputField
                      isRequired={true}
                      fieldname="name"
                      label="Title / Subject"
                      control={control}
                      rules={{
                        required: "Please enter Title",
                      }}
                      initValue=""
                      validate={errors.name && "error"}
                      validMessage={errors.key && errors.name.message}
                    />
                  </Col>
                  <Col span={8}>
                    {contentCategories && (
                      <SelectField
                        isRequired={true}
                        fieldname="cms_categories"
                        label="Categories"
                        control={control}
                        iProps={{
                          placeholder: "Select categories",
                          isMulti: true,
                        }}
                        rules={{ required: "Please select categories" }}
                        selectOption={contentCategories.map((e) => {
                          return { value: e.id, label: e.name };
                        })}
                        validate={errors.cms_categories && "error"}
                        validMessage={
                          errors.cms_categories && errors.cms_categories.message
                        }
                      />
                    )}
                  </Col>

                  <Col span={24}>
                    <Paragraph className="ag-primary">Body</Paragraph>
                    <Editor
                      editorState={editorState}
                      wrapperClassName="editor-main"
                      editorClassName="editor-body"
                      onEditorStateChange={onEditorStateChange}
                    />
                  </Col>
                  <Col span={24} className="mt-1">
                    <Row justify="space-between">
                      <Button size="large" onClick={() => history("/cms")}>
                        Cancel
                      </Button>
                      <Button htmlType="submit" type="primary" size="large">
                        Update
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </DashboardLayout>
    </Spin>
  );
};

export default CMSDetail;
